import { render, staticRenderFns } from "./EscalationDetails.vue?vue&type=template&id=64f715b4&"
import script from "./EscalationDetails.vue?vue&type=script&lang=ts&"
export * from "./EscalationDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports